import './BaseStatusCode.81a608fb496aae801dc7b670a1aea408.css';
export default {"statusCode":"_statusCode_15ua8_1","textContent":"_textContent_15ua8_1"};